import * as i0 from '@angular/core';
import * as i1 from './crnk.expression.form.module';
import * as i2 from '@angular/forms';
import * as i3 from './crnk.expression.form.model.default';
import * as i4 from './crnk.expression.form.model.form';
import * as i5 from './crnk.expression.form.model.accessor';
import * as i6 from './crnk.expression.form.validators.base';
import * as i7 from './crnk.expression.form.validators.jsonapi';
export const CrnkExpressionFormModuleNgFactory:i0.NgModuleFactory<i1.CrnkExpressionFormModule> = (null as any);
var _decl0_0:i2.ɵbf = (<any>(null as any));
var _decl0_1:i2.NgSelectOption = (<any>(null as any));
var _decl0_2:i2.ɵq = (<any>(null as any));
var _decl0_3:i2.DefaultValueAccessor = (<any>(null as any));
var _decl0_4:i2.ɵbc = (<any>(null as any));
var _decl0_5:i2.ɵbe = (<any>(null as any));
var _decl0_6:i2.CheckboxControlValueAccessor = (<any>(null as any));
var _decl0_7:i2.SelectControlValueAccessor = (<any>(null as any));
var _decl0_8:i2.SelectMultipleControlValueAccessor = (<any>(null as any));
var _decl0_9:i2.RadioControlValueAccessor = (<any>(null as any));
var _decl0_10:i2.NgControlStatus = (<any>(null as any));
var _decl0_11:i2.NgControlStatusGroup = (<any>(null as any));
var _decl0_12:i2.RequiredValidator = (<any>(null as any));
var _decl0_13:i2.MinLengthValidator = (<any>(null as any));
var _decl0_14:i2.MaxLengthValidator = (<any>(null as any));
var _decl0_15:i2.PatternValidator = (<any>(null as any));
var _decl0_16:i2.CheckboxRequiredValidator = (<any>(null as any));
var _decl0_17:i2.EmailValidator = (<any>(null as any));
var _decl0_18:i2.NgModel = (<any>(null as any));
var _decl0_19:i2.NgModelGroup = (<any>(null as any));
var _decl0_20:i2.NgForm = (<any>(null as any));
var _decl0_21:i3.ExpressionDirective = (<any>(null as any));
var _decl0_22:i4.FormExpressionDirective = (<any>(null as any));
var _decl0_23:i5.ExpressionDefaultValueAccessorDirective = (<any>(null as any));
var _decl0_24:i6.ExpressionPatternValidatorDirective = (<any>(null as any));
var _decl0_25:i6.ExpressionMaxLengthValidatorDirective = (<any>(null as any));
var _decl0_26:i6.ExpressionMinLengthValidatorDirective = (<any>(null as any));
var _decl0_27:i6.ExpressionCheckboxRequiredValidatorDirective = (<any>(null as any));
var _decl0_28:i6.ExpressionRequiredValidatorDirective = (<any>(null as any));
var _decl0_29:i6.ExpressionEmailValidatorDirective = (<any>(null as any));
var _decl0_30:i7.ResourceValidatorDirective = (<any>(null as any));
var _decl0_32:i2.FormsModule = (<any>(null as any));
var _decl0_33:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_34:i0.ElementRef = (<any>(null as any));
